// extracted by mini-css-extract-plugin
export default {"chip-root":"efb93dwk30FWpOy_sRyH","disabled-chip":"YjWuFBOVrtFG5_OgY2LF","chip-not-text":"_iWFl3CbuNHOhuuOii5d"};